import {createAction} from '@reduxjs/toolkit';

import type {ClientThread} from '../types/extended';

export const receivedThread = createAction<ClientThread>('threads/actions/receivedThread');
